/**
 * @file: transformOrigin.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ViewStyle } from 'react-native';

interface Point2D {
  x: number;
  y: number;
}

export const transformationsByTransformOrigin = (
  { x, y }: { x: number; y: number },
  ...transformations: any[]
) => {
  'worklet';
  return [
    { translateX: x },
    { translateY: y },
    // eslint-disable-next-line reanimated/unsupported-syntax
    ...transformations,
    { translateX: x * -1 },
    { translateY: y * -1 },
  ];
};

export const transformationsWithTransformOrigin = (
  anchorPoint: Point2D,
  originalCenterPoint: Point2D,
  transforms: ViewStyle['transform'] = [],
) => {
  // To rotate counter-clockwise around bottom-left corner:
  // 1. Translate so bottom-left corner is at origin
  // 2. make other transformations
  // 3. Translate back to original position
  const result = [
    { translateX: anchorPoint.x - originalCenterPoint.x },
    { translateY: anchorPoint.y - originalCenterPoint.y },
    ...transforms,
    { translateX: -(anchorPoint.x - originalCenterPoint.x) },
    { translateY: -(anchorPoint.y - originalCenterPoint.y) },
  ];

  return result;
};

export const transformationsWithTransformOriginAnimated = (
  anchorPoint: Point2D,
  originalCenterPoint: Point2D,
  transform: any,
) => {
  'worklet';
  // To rotate counter-clockwise around bottom-left corner:
  // 1. Translate so bottom-left corner is at origin
  // 2. make other transformations
  // 3. Translate back to original position
  const result: any[] = [
    { translateX: anchorPoint.x - originalCenterPoint.x },
    { translateY: anchorPoint.y - originalCenterPoint.y },
    transform,
    { translateX: -(anchorPoint.x - originalCenterPoint.x) },
    { translateY: -(anchorPoint.y - originalCenterPoint.y) },
  ];

  return result;
};
